import {
  Component,
  OnInit,
  Input,
  Injectable,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ApplicationService } from "app/services/application.service";
import { StatusService } from "app/services/status.service";
import { AuthWebService } from "app/services/authweb.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { ToastrService } from "ngx-toastr";
import {
  Router,
  ActivatedRoute,
  Params,
  RouteConfigLoadStart,
} from "@angular/router";
import { VehicleEntryService } from "app/services/vehicle-entry.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { CountryService } from "app/services/country.service";
import { VehicleMakeService } from "app/services/vehicle-make.service";
import { VehicleTypeService } from "app/services/vehicle-type.service";
import { environment } from "../../../../../src/environments/environment";
import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { VehicleService } from "app/services/vehicle.service";
import { Location, DatePipe } from "@angular/common";
import { PermitTypeService } from "app/services/permit-type.service";
import { VehicleEntryCarrierService } from "app/services/vehicle-entry-carrier.service";
import { PopupService } from "app/services/shared/popup.service";
import { Baseservice } from "app/services/baseservice";
import { DocumenttypeService } from "app/services/documenttype.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ReturnStatement } from "@angular/compiler";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { PDFDocumentProxy } from "ng2-pdf-viewer";
import { FilterService } from "../../../shared/filter/filter.service";
import { CarrierDepotService } from "../../../carrier-depot/service/carrier-depot.service";

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = "/";

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = "DD/MM/YYYY";

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT);
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return "";
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return "";
    return mdt.format(this.DT_FORMAT);
  }
}

declare var $;
@Component({
  selector: "app-display-manage-vehicles",
  templateUrl: "./display-manage-vehicles.component.html",
  styleUrls: ["./display-manage-vehicles.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    NgbActiveModal,
  ],
})
export class DisplayManageVehiclesComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  @Input() carrireAccountNumber: any;
  @Input() data: any;
  permits: any = [];
  currentDate = {
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  };
  statuses: any = [];
  flags = {
    flagAN: 1,
    flagNM: 1,
    flagLU: 1,
    flagCT: 1,
    flagAP: 1,
    flagPT: 1,
    flagST: 1,
    flagDS: 1,
  };
  ranks = {
    flagAN: 1,
    flagNM: 2,
    flagLU: 3,
    flagCT: 4,
    flagAP: 5,
    flagPT: 6,
    flagST: 7,
    flagDS: 8,
  };
  sortLabels = {
    flagAN: "AccountNumber",
    flagNM: "Name",
    flagLU: "LeadUser",
    flagCT: "CarrierType",
    flagAP: "ApplicationNumber",
    flagPT: "PermitType",
    flagST: "Status",
    flagDS: "DateSubmitted",
  };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 8;
  selectedVehicle: any = null;
  isLoading: Boolean = false;
  message: string = "Loading  vehicles, please wait...";
  statuses1: any = [];
  currentpage: any = 1;
  isExternalRole: boolean = true;
  //Search Variables
  eNatisCounter = 0;
  vehicletypes: any = [];
  permittypes: any = [];
  vinnumber: string;
  vehicleType: string = "";
  permitType: string = "";
  regnumber: string;
  carriername: string;
  carriercode: string;
  found = false;
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  IsSearching: boolean = false;
  IsAdmin: boolean = false;
  pageSize: number = 1000;
  page: any = 1;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  isManageVehicles: boolean = false;
  dropdownSettings: any = {};
  registerNumber: string;
  isDef: boolean = true;
  vehicleRes: any = [];
  isEditData: boolean = false;
  isViewData: boolean = false;
  myForm: FormGroup;
  ddlCountries: any = [];
  ddlDepots: any = [];
  list_vehicle_make: any = [];
  list_vehicle_type: any = [];
  list_vehicle_types: any = [];
  selectedVMake: any;
  btnAddNew: boolean;
  leased: any;
  appid: any = null;
  @Input() dataCntrl: any;
  isMyVehicles = false;
  permit_type_id: any;
  isSame = false;
  myAppVehicles = [];
  isPermitApplication: boolean = true;

  model: NgbDateStruct;
  date: { year: number };
  selectedVehicles: any = [];
  selectedCountry: any = null;
  selectedDepot: any = null;

  carrierId: any;
  isVehicleLoading: boolean = false;
  isDocumentLoading: boolean = false;
  uploadedDocs;
  maxMB: any = "5MB";
  dtype: any = "PDF,JPG,PNG,JPEG";
  docTypeId: any;
  filebytes: string;
  filename: any;
  filetype: any;
  isPhonePortrait = false;
  subIndex: any;
  isHandsetLandscape = false;
  filedescription: string;
  filesize: any;
  user = { LastName: "" };
  vehicleId: number;
  documentType: any;
  isLoadingImg: boolean;
  selectItem: any;
  viewDocuments: any = [];
  DocumentsToUpload: any = [];
  pdfSrc: any;
  img: any;

  linkedDocs: any;
  isExtra: boolean;
  eNatisResult: any = null;

  isReplacement: boolean = false;
  vehiclesReplacement: any = [];
  vehiclesReplace: any = [];
  isSouthAfrica = true;
  disallowEdit = false;
  currentVehicle: any = [];
  classMessage: string;
  wrongClass: boolean;
  curr_permit_type_id: number;
  freight_passenger_ind: any;
  vehicleGVMs: any = [];
  @ViewChild("country_id") mySelectedCountry: ElementRef<HTMLSelectElement>;

  constructor(
    private toastr: ToastrService,
    private vehicleEntryService: VehicleEntryService,
    private countryService: CountryService,
    private vehicleMakeService: VehicleMakeService,
    private authWebService: AuthWebService,
    private vehicleTypeService: VehicleTypeService,
    private permitTypeService: PermitTypeService,
    public utility: UtilityServiceService,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private vehicleService: VehicleService,
    private responsive: BreakpointObserver,
    private _location: Location,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private toastService: ToastNotificationService,
    private applicationService: ApplicationService,
    private vehicleEntryCarierService: VehicleEntryCarrierService,
    private msgService: PopupService,
    private documenttypeSerivce: DocumenttypeService,
    private documentService: DocumentsServiceService,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private showModal: PopupService,
    private filter: FilterService,
    private confirmDialogService: ConfirmDialogService,
    private carrierDepotService: CarrierDepotService
  ) {
    this.activeRoute.params.subscribe((params: Params) => {
      this.appid = params["appid"];
      this.carrierId = this.data;
      this.carriercode = this.carrireAccountNumber;
      if (this.carriercode) {
        this.isPermitApplication = false;
      }
      this.carrierId = params["carrierid"];
    });
    if (this.router.url.indexOf("vehicle-replace") > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.appid = params["appid"];
        this.getApp(params["appid"]);
      });
      this.isReplacement = true;
    }
  }

  ngOnInit() {
    this.carrierId = this.data;
    this.carriercode = this.carrireAccountNumber;
    if (this.carriercode) {
      this.isPermitApplication = false;
    }
    this.responsive
      .observe([Breakpoints.HandsetLandscape, Breakpoints.TabletLandscape])
      .subscribe((result) => {
        this.isPhonePortrait = false;
        this.isHandsetLandscape = false;

        if (result.matches) {
          this.isPhonePortrait = true;
        }
        if (result.matches) {
          this.isHandsetLandscape = true;
        }
      });
    this.isManageVehicles = this.router.url.indexOf("vehicles") > 0;
    if (
      environment.authWebApi.systemData != null &&
      environment.authWebApi.systemData.Configurations != null
    ) {
      this.maxMB = environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "MaxUploadMB1"
      ).Value;
      this.dtype = environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "UploadDocTypes1"
      ).Value;
    }
    this.initKeyword();
     this.listCountries();
    this.getVehicles();
    this.loadvehicletypes();
    this.listDepot();
    this.createForm();
    this.user.LastName = this.authWebService.userData
      ? this.authWebService.userData.User.LastName
      : "";
    this.selectedCountry = "South Africa";
    this.disable();

    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = false;
    }
  }
  listDepot() {
    this.carrierDepotService.getDepotByCarrier(this.carrierId).subscribe(
        (result) => {
            this.ddlDepots = result;
            //console.log(result);
        },
        (error) => {
            //console.log(error);
        }
    );

}
  createForm() {
    this.isEditData = false;
    this.isViewData = false;
    this.isSouthAfrica = true;
    this.myForm = this.formBuilder.group({
      id: [-1, []],
      permit_id: [],
      country_id: ["", [Validators.required]],
      registration_number: ["", [Validators.required]],
      registration_year: ["", [Validators.required]],
      depot_id: [""],
      vehicle_make_id: ["", []],
      vehicle_series: ["", []],
      vehicle_model: ["", []],
      vehicle_colour: ["", []],
      vin: ["", [Validators.required]],
      engine_number: ["", [Validators.required]],
      gvn: ["", [Validators.required]],
      seating_capacity: ["", []],
      date_license_expiry: ["", [Validators.required]],
      start_date: ["", [Validators.required]],
      vehicle_state: ["", []],
      roadworthy_status: ["", [Validators.required]],
      vehicle_owner: ["", []],
      is_leased: [null, [Validators.required]],
      vehicle_lessor: [""],
      vehicle_lessee: [""],
      date_lease_expiry: [""],
      vehicle_type_id: ["", [Validators.required]],
      api_date_updated: ["", []],
      eNatis_num: ["", []],
    });
    this.disable();
    //this.LeaseChange(event); // hides the lease container
    this.found = false; // hides the 'Retrieve from eNatis' button
    this.disallowEdit = false; // allow fields to be edited
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
    this.DocumentsToUpload = [];
    this.viewDocuments = [];
    this.uploadedDocs = this.uploadedDocs?.filter(
      (x) => x.description !== "Travel Itinerary"
    );
    this.selectedCountry = "South Africa";
  }

  passForEdit(item) {
    this.isEditData = true;
    this.vehicleService.getVehicleBy(item.id).subscribe((x: any) => {
      this.leased = x.is_leased;
      this.myForm.patchValue({
        id: item.id,
        date_license_expiry: this.datePipe.transform(
          item.date_license_expiry,
          "dd/MM/yyyy"
        ),
        gvn: item.gvn,
        registration_number: item.registration_number,
        registration_year: item.registration_year,
        depot_id: item.depot_id,
        seating_capacity: x.seating_capacity,
        start_date: item.start_date,
        vehicle_make_id: item.vehicle_make_id,
        vehicle_type_id: item.vehicle_type_id,
        vin: item.vin,
        permit_id: x.permit_id,
        country_id: x.country_id,
        vehicle_series: x.vehicle_series,
        vehicle_model: x.vehicle_model,
        vehicle_colour: x.vehicle_colour,
        engine_number: x.engine_number,
        vehicle_state: x.vehicle_state,
        roadworthy_status: x.roadworthy_status,
        vehicle_owner: x.vehicle_owner,
        is_leased: x.is_leased,
        vehicle_lessor: x.vehicle_lessor,
        vehicle_lessee: x.vehicle_lessee,
        date_lease_expiry: this.datePipe.transform(
          x.date_lease_expiry,
          "dd/MM/yyyy"
        ),
      });
    });
  }

  checkVin(value) {
    if (value.length > 0) {
      if (this.selectedCountry == "South Africa") {
        // this.eNatisUpdate();
        this.found = true; // displays the "Retrieve from eNatis" button
        this.disable();
      }
    } else {
      // if (value.length === 0) {
      this.found = false; // hides the "Retrieve from eNatis" button
      this.enable();
      // }
    }

    if (value.length === 17 && this.selectedCountry == "South Africa") {
      this.eNatisUpdate();
    }
  }

  eNatisUpdate() {
    this.eNatisCounter = this.eNatisCounter + 1;
    this.isVehicleLoading = true;
    // this.found = false
    this.message = "Checking vehicle, please wait...";
    this.vehicleService
      .getVehicleValidatorByVin(this.myForm.value.vin)
      .subscribe((data: any) => {
        if (data.Vin !== null) {
          this.eNatisResult = data;
          this.myForm.patchValue({
            country_id: 113,
            vin: data.Vin,
            registration_number: data.Registration_number,
            vehicle_owner: data.Ownership,
            registration_year: data.Registration_year,
            vehicle_colour: data.Vehicle_colour,
            vehicle_model: data.Vehicle_model,
            gvn: data.Gvm,
            engine_number: data.Engine_number,
            roadworthy_status: data.roadworthystatus,
            eNatis_num: data.enatis_num,
            date_license_expiry: this.datePipe.transform(
              data.Date_license_expiry,
              "dd/MM/yyyy"
            ),
            seating_capacity: data.Seating_capacity,
          });
          this.isVehicleLoading = false;
          this.isSouthAfrica = true;

          if (data.roadworthystatus != "Roadworthy") {
            return this.toastService.error(
              "Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.",
              "Vehicle"
            );
          } else {
            return this.toastService.success(
              "Vehicle data found successfully on eNatis database. Please continue...",
              "Vehicle"
            );
          }
        }

        if (data.NotFound === "Not found") {
          // try 3 times to retrieve eNatis detail before displaying a failure message
          if (this.eNatisCounter <= 3) {
            this.eNatisUpdate();
            return;
          }
          // this.toastr.info('VIN and registration number do not match.');
          this.toastService.error(
            "Wasn't able to retrieve vehicle detail from eNatis - Please confirm VIN number is correct or try again later.\nAlternatively please enter the vehicle details manually.",
            "Vehicle"
          );
          this.isVehicleLoading = false;
          this.eNatisResult = null;
          this.enable();
          if (this.isEditData == true) {
            this.isSouthAfrica = true;
            this.disallowEdit = true;
          }
          return;
        } else {
          this.eNatisCounter = 0;
        }

        if (data.NetworkError === "Network error") {
          this.toastService.error(
            "The system is offline at the moment, please try again later or You can add Vehicle details Manually",
            "Error"
          );
          this.isVehicleLoading = false;
          this.enable();
          this.isSouthAfrica = false;
          this.disallowEdit = false;
          this.eNatisResult = null;
          // this.close();
          return;
        }
      });
  }

  getPermitsAppVecleEntry(id) {
    this.vehicleService.getPermitsAppVecleEntry(id).subscribe((data: any) => {
      this.myAppVehicles = data;
    });
  }

  getCarrierPermitsAppVecleEntry(id, appid) {
    this.vehicleService
      .getCarrierPermitsAppVecleEntry(id, appid)
      .subscribe((data: any) => {
        this.vehicleRes = data;
        this.count = data.length;
        if (this.count == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        this.isLoading = false;
        this.isMyVehicles = true;
      });
  }

  checkVehicle(event, item, res) {
    if (event.currentTarget.checked && this.isPermitApplication) {
      // this.selectedVehicle = true;
      this.selectedVehicle = res;
      this.vehicleService
        .isVehicleAttachedToPermit(item.id, this.carrierId)
        .subscribe((result) => {
          if (result == true) {
            return this.toastService.error(
              "This vehicle is already in a permit",
              "Vehicle"
            );
          }
        });
      this.getVehicleTypeForM(item);
    }
    if (event.currentTarget.checked && !this.isPermitApplication) {
      // this.selectedVehicle = true;
      this.selectedVehicle = res;
    }
    if (!event.currentTarget.checked) {
      const index: number = this.selectedVehicles.indexOf(item);
      if (index !== -1) {
        this.selectedVehicles.splice(index, 1);
      }
    }
  }

  getApp(id) {
    this.isLoading = true;
    if (id)
      this.applicationService.getById(id).subscribe((data: any) => {
        this.ctrlData = data;
        this.currentVehicle = data.vehicle > 0 ? data.vehicle[0] : null;
        this.curr_permit_type_id = data.permit_type_id;
        this.permit_type_id = data.permit_type_id;

        if (
          data.permit_type.freight_passenger_ind != null &&
          data.permit_type.freight_passenger_ind != undefined
        ) {
          this.freight_passenger_ind = data.permit_type.freight_passenger_ind;
        }

        this.carrierId = data.carrier_id;
        this.getVehicleType(data.permit_type_id);
        this.getCarrierPermitsAppVecleEntry(data.carrier_id, id);
      });
    else this.isVehicleLoading = false;
  }

  onBack() {
    if (localStorage.getItem("replaceFlag") == "true") {
      let url: any = `carrier/permit/application/change/${this.appid}/vehicle`;
      this.router.navigate([url]);
    } else {
      this.router.navigate([
        "/carrier/permit/application/edit/" + this.appid + "/" + true,
      ]);
    }
  }

  getVehicles() {
    if (this.appid === null || this.appid === undefined) {
      this.isLoading = true;
      this.onSearch();
    } else {
      this.isLoading = true;
      this.onSearch();
    }
  }

  loadvehicletypes = () => {
    this.vehicleTypeService.loadvehicletypes().subscribe((result) => {
      this.vehicletypes = result;
      //Only take the correct vehicles for the chosen permit type
    });
  };

  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "desc",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1000,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 120,
      closeDropDownOnSelection: false,
    };
  }

  onItemSelect(item: any) {}

  onReset = () => {
    this.message = "Loading vehicles, please wait...";
    this.onSearch();
    this.selectedVehicle = null;
    this.IsSearching = false;
    this.getApp(this.appid);
    document.getElementById("btnSearch").click();
  };

  setSearchKeywords = () => {};

  initKeyword = () => {};

  onCarrierSearch = (page: number = 1, pageSize: number = 1000) => {
    this.IsSearching = true;
    this.IsAdmin = false;
    this.utility.page = 1;
    this.isLoading = true;
    this.vehicleRes = [];
    this.message = "Searching your vehicles, please wait...";

    if (this.vehicleType === "") {
      this.vehicleType = null;
    }

    if (this.vinnumber === "") {
      this.vinnumber = null;
    }

    if (this.regnumber === "") {
      this.regnumber = null;
    }

    if (this.carriername === "") {
      this.carriername = null;
    }

    if (this.carriercode === "") {
      this.carriercode = null;
    }

    let object = {
      VehicleType: this.vehicleType,
      PermitType: this.permitType,
      VIN: this.vinnumber,
      Regnumber: this.regnumber,
      Carriername: this.carriername,
      CarrierId: this.carrierId,
      carriercode: this.carriercode,
      PageSize: pageSize,
      PageNumber: page,
    };

    this.vehicleEntryService.searchCarrierVehicle(object).subscribe(
      (result: any) => {
        if (result == null) {
          this.vehicleRes = [];
          this.isEmpty = true;
          this.isLoading = false;
          return;
        }
        this.vehicleRes = result;

        this.isLoading = false;
        this.count = result.length;
        if (result.length == 0) {
          this.isEmpty = true;
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  };

  onChange = () => {
    if (this.IsAdmin) {
      this.onSearch((this.utility.page = 1), this.pageSize);
    } else {
      this.onCarrierSearch((this.utility.page = 1), this.pageSize);
    }
  };

  onSearch = (page: number = 1, pageSize: number = 1000) => {
    this.IsSearching = true;
    this.isLoading = true;
    this.message = "Searching vehicles, please wait...";

    if (!this.isExternalRole) {
      this.carriercode = null;
      this.carrierId = null;
    }

    this.filter.getData().subscribe((data) => {
      this.vehicleType = data.vehicleType ? data.vehicleType : "";
      this.vinnumber = data.vinNumber ? data.vinNumber : "";
      this.regnumber = data.regnumber ? data.regnumber : "";
    });

    if (this.vehicleType === "") {
      this.vehicleType = null;
    }

    if (this.vinnumber === "") {
      this.vinnumber = null;
    }

    if (this.regnumber === "") {
      this.regnumber = null;
    }

    if (this.carriername === "") {
      this.carriername = null;
    }

    if (this.carriercode === "") {
      this.carriercode = null;
    }

    let object = {
      VehicleType: this.vehicleType,
      PermitType: this.permitType,
      VIN: this.vinnumber,
      Regnumber: this.regnumber,
      Carriername: this.carriername,
      carriercode: this.carriercode,
      CarrierId: this.carrierId,
      PageSize: pageSize,
      PageNumber: page,
    };

    this.vehicleEntryService.searchVehicleV2(object).subscribe(
      (result: any) => {
        if (result == null) {
          this.vehicleRes = [];
          this.isLoading = false;
          return;
        }
        this.vehicleRes = result.Items;
        this.isLoading = false;
        this.count = result.Count;
        this.utility.onSort(1);
        if (result.Items.length == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  };

  onNextOrPrevious(page: number) {
    if (this.IsAdmin) {
      this.onSearch(page, this.pageSize);
    } else {
      this.onCarrierSearch(page, this.pageSize);
    }

    this.currentPage = page;
    return page;
  }

  listCountries() {
    this.countryService.listCountries().subscribe(
      (result) => {
        this.ddlCountries = result;
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  getVehicleType(id) {
    this.vehicleTypeService.getPermitTypeVehicles().subscribe(
      (result: any) => {
        this.list_vehicle_type = result.filter((x) => x.permit_type_id === id);
        if (this.list_vehicle_type.length > 0) {
          this.btnAddNew = true;
        }
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  getVehicleTypeForM(item) {
    this.isLoading = true;
    this.message = "Checking vehicle...";
    this.vehicleTypeService.getPermitTypeVehicles().subscribe(
      (result: any) => {
        this.list_vehicle_types = result.filter(
          (x) => x.permit_type_id === this.permit_type_id
        );
        if (this.list_vehicle_type.length == 0) {
          this.isLoading = false;
          this.toastService.error(
            "No vehicle types have been linked to this permit type. Please update the Corporate Reference Data link..",
            "SYSTEM ERROR"
          );
          return;
        }
        let ptId = this.list_vehicle_types[0].permit_type_id;
        let permitDescRecord: any = this.permittypes.find((p) => p.id == ptId);
        let permitDesc = permitDescRecord.description.toUpperCase();
        let check = this.list_vehicle_types.find(
          (x) => x.vehicle_type_id === item.vehicle_type_id
        );

        if (check !== undefined) {
          if (
            item.VehicleEntry.is_leased == true &&
            (permitDesc.search("TAXI") != -1 ||
              permitDesc.search("ORGANISED GROUP") != -1 ||
              permitDesc.search("ORGANIZED GROUP") != -1)
          ) {
            this.toastService.error(
              "This permit type is not issued for leased vehicles.",
              "Vehicle"
            );
          } else if (this.isReplacement) {
            this.checkVehicleClass(item);
            if (this.wrongClass) {
              this.toastService.error(this.classMessage, "Replace Vehicle");
            } else {
              this.selectedVehicles.push(item);
            }
          } else {
            this.selectedVehicles.push(item);
          }
        }
        if (check === undefined) {
          this.toastService.error(
            "Please select a suitable vehicle type for the type of permit on your application.",
            "Vehicle Selection"
          );
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  getVehiclesReplacement() {
    this.vehicleService.getAllVehicles().subscribe((data) => {
      this.vehiclesReplacement = data;
    });
  }

  editVehicle(item) {
    this.isLoading = true;
    this.isVehicleLoading = true;
    this.eNatisResult = null;
    $(".action").val("null");
    this.vehicleEntryService.getVehicleDeatilsById(item).subscribe((x: any) => {
      this.isLoading = false;
      // this.vehicleEntryService.getVehicleEntryById(item.id).subscribe(x=>{
      if (x != null) {
        this.leased = x.VehicleEntry.is_leased;

        if (x.VehicleEntry.country_id == 113) {
          this.isSouthAfrica = true;
        } else {
          this.isSouthAfrica = false;
        }

        // this.isEditData = true;

        this.myForm.patchValue({
          id: x.VehicleEntry.id,
          date_license_expiry: this.datePipe.transform(
            x.VehicleEntry.date_license_expiry,
            "dd/MM/yyyy"
          ),
          gvn: x.VehicleEntry.gvn,
          registration_number: x.VehicleEntry.registration_number,
          registration_year: x.VehicleEntry.registration_year,
          depot_id: x.depot_id,
          seating_capacity: x.VehicleEntry.seating_capacity,
          start_date: this.datePipe.transform(x.start_date, "dd/MM/yyyy"),
          vehicle_make_id: x.VehicleEntry.vehicle_make_id,
          vehicle_type_id: x.VehicleEntry.vehicle_type_id,
          vin: x.VehicleEntry.vin,
          permit_id: x.permit_id,
          country_id: x.VehicleEntry.country_id,
          vehicle_series: x.VehicleEntry.vehicle_series,
          vehicle_model: x.VehicleEntry.vehicle_model,
          vehicle_colour: x.VehicleEntry.vehicle_colour,
          engine_number: x.VehicleEntry.engine_number,
          eNatis_num: x.VehicleEntry.vehicle_register_num,
          vehicle_state: x.vehicle_state,
          roadworthy_status: x.VehicleEntry.roadworthy_status,
          vehicle_owner: x.VehicleEntry.vehicle_owner,
          is_leased: x.VehicleEntry.is_leased,
          vehicle_lessor: x.VehicleEntry.vehicle_lessor,
          vehicle_lessee: x.VehicleEntry.vehicle_lessee,
          date_lease_expiry: this.datePipe.transform(
            x.VehicleEntry.date_lease_expiry,
            "dd/MM/yyyy"
          ),
        });
        // this.LeaseChange(event);
        console.log(this.ddlDepots)
console.log(this.myForm.value)
        if (x.country_id === 113) {
          this.isSouthAfrica = true;
          this.disallowEdit = true;
        }

        // this.eNatisForUpdate();
        document.getElementById("myButton").click();

        // $("#addEdit").modal('show');
      }
      this.isVehicleLoading = false;
    });
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  selectCountry(countryCode) {
    let list: any = this.ddlCountries.filter((map) => {
      return map.id == countryCode.value;
    });
    if (list != null && list.length > 0) {
      this.selectedCountry = list[0];
    }
  }

  checkRoadworthy(event: any) {
    if (event.target.value != "Roadworthy") {
      if (this.myForm.value.country_id === 113) {
        this.toastService.error(
          "Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.",
          "Vehicle"
        );
      } else {
        this.toastService.error(
          "Please note that according to your selection this vehicle is not roadworthy and therefore will not be eligible for permit application.",
          "Vehicle"
        );
      }
      return;
    }
  }

  // checkCountrySelection (event: any) {
  //   if (!this.myForm.value.country_id) {
  //        this.toastr.info("Please select the vehicle's Country-of-Registration before continuing.")
  //    return
  //   }
  // }

  CloseModal() {
    // $("#addEdit").modal('hide');
    document.getElementById("closeModal").click();
    this.isEditData = false;
    this.disallowEdit = false;
    this.leased = false;
    this.isViewData = false;
    this.isSouthAfrica = false;
    this.isVehicleLoading = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
    // this.myForm.controls.carrier_id.enable();
  }

  // selectAction(actionType, res) {

  //   if (actionType.value == "view") {
  //     this.isViewData = true;
  //     this.isEditData = false;
  //     this.editVehicle(res);
  //     this.myForm.controls.country_id.disable();
  //     this.myForm.controls.roadworthy_status.disable();
  //     this.myForm.controls.vehicle_type_id.disable();
  //     this.myForm.controls.is_leased.disable();

  //   } else if (actionType.value == "edit") {
  //     this.isEditData = true;
  //     this.isViewData = false;
  //     this.editVehicle(res);
  //     this.myForm.controls.country_id.enable();
  //     this.myForm.controls.roadworthy_status.enable();
  //     this.myForm.controls.vehicle_type_id.enable();
  //     this.myForm.controls.is_leased.enable();

  //   }
  //   if (actionType.value == "delete") {
  //     this.OndeleteVehicle(res);
  //   }
  //   if (actionType.value == "upload") {
  //     this.selectItem = res;
  //     this.uploadDocs(res);
  //   }
  //   return;
  // }

  logError(error) {
    console.error(error);
  }

  disable() {
    this.eNatisResult = true;
  }

  enable() {}

  close() {
    this.isSouthAfrica = false;
    this.disallowEdit = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
  }

  checkVehicleClass(item) {
    this.wrongClass = false;
    var currentVehicleMeasure: number;
    var newVehicleMeasure: number;
    var result = this.permittypes.find((x) => x.id == this.curr_permit_type_id);
    if (this.currentVehicle != undefined) {
      var thisPermitType =
        result.freight_passenger_ind == 1 ? "freight" : "passenger";
      if (thisPermitType == "passenger") {
        currentVehicleMeasure = this.currentVehicle.seating_capacity;
        newVehicleMeasure = item.VehicleEntry.seating_capacity;
        if (
          (currentVehicleMeasure > 35 && newVehicleMeasure <= 35) ||
          (currentVehicleMeasure <= 35 && newVehicleMeasure > 35)
        ) {
          this.wrongClass = true;
          this.classMessage = `------- Passenger Vehicles -------- Class 1 = seating capacity 35 or less Class 2 = seating capacity over 35`;
        }
      } else {
        currentVehicleMeasure = this.currentVehicle.gvn;
        newVehicleMeasure = item.VehicleEntry.gvn;
        if (
          (currentVehicleMeasure > 20000 && newVehicleMeasure <= 20000) ||
          (currentVehicleMeasure <= 20000 && newVehicleMeasure > 20000)
        ) {
          this.wrongClass = true;
          this.classMessage = `--------- Freight Vehicles --------- Class 1 = GVM of 20 000kg or less Class 2 = GVM more than 20 000kg`;
        }
      }
      if (this.wrongClass) {
        this.classMessage = `You can only replace a vehicle with another vehicle of the same class . . . ${this.classMessage}`;
      }
    }
    return this.wrongClass;
  }

  cabotageTrailer(vcleType) {
    // this.chkboxToolTip = 'Select vehicle to the application'
    if (vcleType == "TRAILER") {
      let prmType = this.permittypes.find((p) => p.id == this.permit_type_id);
      if (prmType != undefined && prmType.code.substring(0, 3) != "CAB") {
        // this.chkboxToolTip = `'TRAILER' is only applicable for 'Cabotage' permit types.`
        return true;
      }
    }
    return false;
  }

  chkboxToolTip(vcleType) {
    this.uploadedDocs = this.uploadedDocs.filter(
      (x) => x.description !== "Travel Itinerary"
    );
    if (vcleType == "TRAILER") {
      let prmType = this.permittypes.find((p) => p.id == this.permit_type_id);
      if (prmType != undefined && prmType.code.substring(0, 3) != "CAB") {
        return `'TRAILER' is only applicable for 'Cabotage' permit types.`;
      }
    }
    return "Select vehicle to the application";
  }

  chkboxTool(event, item) {
    if (event.currentTarget.checked) {
      this.selectedVehicle = item;
    } else {
      this.selectedVehicle = null;
    }
  }

  onError(error: any) {
    // do anything
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    //this.totalPages = pdf.numPages;
  }

  getYear(date: Date) {
    return this.datePipe.transform(date, "y");
  }

  actionClicked(res) {
    this.isViewData = true;
    this.isEditData = false;
    this.editVehicle(res.id);
    this.myForm.controls.country_id.disable();
    this.myForm.controls.roadworthy_status.disable();
    this.myForm.controls.vehicle_type_id.disable();
    this.myForm.controls.is_leased.disable();
  }

  checkIfIdExists(id: number): boolean {
    return this.vehicleGVMs.some((item) => item.id === id);
  }
}
